export const localStorage_key_didSeePanel =
  '2022-Q2-PUBLISH-SURVEY_didSeePanel';

export const surveyUrl = 'https://www.surveymonkey.com/r/RFV3PNG';
